import React from "react";
import {useNavigate} from "react-router-dom";
import {DocumentTextIcon, ShieldCheckIcon} from "@heroicons/react/20/solid";
import HeaderLogoOnly from "../header/HeaderLogoOnly";
import Footer from "../footer/FooterCopyrightOnly";

export default function Legal() {
    const navigate = useNavigate();

    const options = [
        {
            key: "terms",
            title: "Terms",
            description: "Read the Terms of Use for VirtualTipz.",
            icon: DocumentTextIcon,
            path: "/terms",
        },
        {
            key: "privacy",
            title: "Privacy",
            description: "Learn how we collect, use, and protect your information.",
            icon: ShieldCheckIcon,
            path: "/privacy",
        },
    ];

    return (
        <>
            <HeaderLogoOnly/>
            <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                        Terms &amp; Privacy
                    </h1>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-400">
                        Select an option below to view the full document.
                    </p>
                </div>

                <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
                    {options.map((option) => (
                        <button
                            key={option.key}
                            type="button"
                            onClick={() => navigate(option.path)}
                            className="group flex w-full flex-col items-center rounded-xl bg-white dark:bg-gray-800 p-8 text-center shadow-sm ring-1 ring-gray-200 dark:ring-gray-700 transition hover:shadow-md hover:ring-pink-300 focus:outline-none focus:ring-2 focus:ring-pink-600"
                        >
                            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-pink-400 text-white">
                                <option.icon className="h-6 w-6" aria-hidden="true"/>
                            </div>
                            <span className="mt-4 text-lg font-semibold text-gray-900 dark:text-gray-100 group-hover:text-pink-600">
                                {option.title}
                            </span>
                            <span className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                {option.description}
                            </span>
                        </button>
                    ))}
                </div>
            </main>
            <Footer/>
        </>
    );
}
